<router-outlet />
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <div class="row g-4">
      <div
        *ngFor="let item of BAC_MAIN_ACTIVITIES_DATA"
        class="col-lg-4 col-md-6 wow fadeInUp"
        data-wow-delay="0.1s"
      >
        <div class="classes-item">
          <div class="bg-light rounded-circle w-75 mx-auto p-3">
            <img
              class="img-fluid rounded-circle"
              src="../../../assets/img/{{ item.image }}"
              alt=""
            />
          </div>
          <div class="bg-light rounded p-4 pt-5 mt-n5 content">
            <a
              class="d-block text-center h3 mt-3 mb-4"
              href="{{ item.link }}"
              >{{ item.title[this.language] }}</a
            >
            <div
              class="row"
              [innerHtml]="item.description[this.language] | urlDetector"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
